import { Injectable } from '@angular/core';
import { GCIDataApi, Sector, Pile, PileUID, Report } from 'gci-data-api';
// @ts-ignore
import PouchDB from 'pouchdb';
// @ts-ignore
import PouchFind from 'pouchdb-find';
import PouchDBAuthentication from "pouchdb-authentication/dist/pouchdb.authentication.js";
import { BehaviorSubject, Subject } from 'rxjs';
import { NotifyService } from './notify.service';

import { LoadingController } from '@ionic/angular';

PouchDB.plugin(PouchFind);
PouchDB.plugin(PouchDBAuthentication);

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export interface DbConfig {
  couchpass: string;
  couchurl: string;
  couchuser: string;
}


export class CurrentSector {
  constructor(
    public sector: Sector,
    public piles: Pile[] = [],
    public attachments: File[] = []
  ) { }
}

let localDB: PouchDB.Database<any>;
let remoteDB: PouchDB.Database<any>;
let dbConfig: DbConfig;
let configChanged: boolean = false;
let hasConfig: boolean = false;

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  get dbConfig(): DbConfig {
    return dbConfig;
  }
  private api: GCIDataApi;
  get localDB(): PouchDB.Database<any> {
    return localDB;
  };
  get remoteDB(): PouchDB.Database<any> {
    return remoteDB;
  };
  currentSectors$: BehaviorSubject<Sector[]> = new BehaviorSubject<Sector[]>([]);
  currentSector$: Subject<Sector> = new Subject<Sector>();
  currentSectorPiles$: BehaviorSubject<Pile[]> = new BehaviorSubject<Pile[]>([]);
  currentPile$: Subject<Pile> = new Subject<Pile>();
  conflicts$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  filterOptions: BehaviorSubject<any> = new BehaviorSubject<any>({});
  _currentSectors: Sector[];
  _currentSector: Sector;
  _currentSectorPiles: Pile[];
  _currentPile: Pile;
  _conflicts: any[];
  _filterOptions:any;
  _loader:any;
  _apiAvailable$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _loaderVisible:boolean = false;
  __CFG:any = JSON.parse(sessionStorage.getItem('_contextOwnerConfig'));
  get _contextOwnerConfig():any{
    return this.__CFG;
  }
  set _contextOwnerConfig(data:any){
    this.__CFG = data;
    sessionStorage.setItem('_contextOwnerConfig', JSON.stringify( this.__CFG ));

  }
  public DBNAME:string;
  dbConnection:string;
  constructor(private notifier:NotifyService, private loader: LoadingController) {
    this.setupLoader();

    // this.dbConnection = new BehaviorSubject<string>();
  }


  async setupLoader(){
    this._loader = await this.loader.create({
     cssClass: 'gci-data-loader',
     message: 'Synchronisation en cours...',
     spinner: 'lines',
     backdropDismiss: false,
     translucent: true
    });
    this._loader.addEventListener('ionLoadingDidDismiss', ()=>{
      console.log('ionLoadingDidDismiss');
      this._loaderVisible=false;
    })


  }
  async presentLoading(){
    if(this._loader && this._loaderVisible){
      return;
    }
    this._loaderVisible=true;
    await this._loader.present();

    return true;
  }

  async stopLoading(){
    if(this._loaderVisible){
      await this._loader.dismiss();
    }
    return true;
  }

  async switchClient( client:string ){
    if(this._contextOwnerConfig && this._contextOwnerConfig.clients && this._contextOwnerConfig.clients.hasOwnProperty(client)){
      console.log('configuring client', client )
      await this.configure(this._contextOwnerConfig.clients[client]);
      console.log('switched client', client )

    }
  }

  async configure(newConfig: DbConfig): Promise<any> {

    if(!this._contextOwnerConfig){
          this._contextOwnerConfig = newConfig;
    }
    if (!hasConfig) {
      dbConfig = newConfig;
      hasConfig = true;
      configChanged = true;
    } else if (dbConfig) {
      hasConfig = true;
      configChanged = Object.keys(dbConfig).some((k: string) => {
        return newConfig[k] != dbConfig[k];
      });
      if (configChanged) {
        // if (newConfig.couchurl) {
        //   newConfig.couchurl = newConfig.couchurl.replace('blanchet-0_0_2', 'blanchet-0_0_3-test');
        // }
        dbConfig = newConfig;
      }
    }
    if (hasConfig && !configChanged) {
      return;
    }
    // const dbname = 'blanchet-0_0_3-test';

    const dbname = dbConfig.couchurl.slice(dbConfig.couchurl.lastIndexOf('/')+1);
//
    let { couchpass, couchuser, couchurl } = dbConfig;
    couchurl = `https://${couchuser}:${couchpass}@data.gestioncirrus.ca/${dbname}`;
    console.log('confoguring DB', dbConfig,dbname);
    this.DBNAME = couchurl;
    if(localDB || remoteDB){
          console.log('closing old db...')
    }
    if(localDB) await localDB.close();
    if(remoteDB) await remoteDB.close();
    await new Promise( (resolve)=>{
      setTimeout( resolve, 1000 );
    });

    localDB = new PouchDB(dbname);
    remoteDB = new PouchDB(couchurl);
    this.dbConnection =  couchurl ;
    console.log("SET API")
    this.api = new GCIDataApi(this.localDB, this.remoteDB, couchuser, couchpass);
    this._apiAvailable$.next( true );
    this.subscribeToSyncEvents(  async (a:any,b:any)=>{
      if(a == 'status'){
        if(b.status == 'active'){
          await this.presentLoading();
        }else if(b.status =='paused'){

          if(this._loader){

            if(!this._currentSectors || (this._currentSectors && !this._currentSectors.length)){
              await this.fetchSectors();
            }

          }
          await this.stopLoading();
        }
      }else if(a =='change'){

        if(this._loaderVisible){
          if(b.direction =='pull'){

            this._loader.message = `réception de ${b.change.pending} documents...`;
          }else{
            this._loader.message = 'envoi de données...';
          }
        }
      }


    })
    return this.api.whenReady().then((api: any) => {

     remoteDB.changes({
        since: 'now',
        live: true,
        include_docs: true
      }).on('change',  (change) => {
        if (change.doc) {
          let doc = change.doc;
          let type = change.id && /^s:\d+$/.test(change.id) ? 'sector' : /^s:\d+:p:.+$/.test(change.id) ? 'pile' : 'unknown';
          if (type == 'pile') {
            if (change.deleted) {
              console.log(change);
              this.notifier.info(`Pile ${change.id} a ete mise a jour`,5000);
              if (this._currentPile && this._currentPile.uid == change.id) {
                this._currentPile = undefined;
                this.currentPile$.next(this._currentPile);
              }
              if (this._currentSectorPiles && this._currentSectorPiles.length) {
                  const foundIndex = this._currentSectorPiles.findIndex((p: any) => {
                    return p.uid == change.id;
                  });
                  if (~foundIndex) {
                    this._currentSectorPiles.splice(foundIndex,1);
                    this.currentSectorPiles$.next(this._currentSectorPiles);
                  }
              }
            } else {
              const newPile = new Pile(doc);
              if (this._currentPile && this._currentPile.uid == change.id) {
                this._currentPile = newPile;
                this.currentPile$.next(this._currentPile);
              }
              if (this._currentSectorPiles && this._currentSectorPiles.length) {
                const foundIndex = this._currentSectorPiles.findIndex((p: any) => {
                  return p.uid == change.id;
                });
                if (~foundIndex) {
                  this._currentSectorPiles[foundIndex] = newPile;
                  this.currentSectorPiles$.next(this._currentSectorPiles);
                } else {
                  if (this._currentSector && this._currentSector.uid == newPile.sector) {

                    this._currentSectorPiles.push(newPile);
                    this.currentSectorPiles$.next(this._currentSectorPiles);
                  }
                }
              }
            }
          }

          else if( type == 'sector'){
              if(change.deleted){
                if(this._currentSector && this._currentSector.uid == change.id ){
                  this._currentSector = undefined;
                  this.currentSector$.next( this._currentSector );
                }
                if(this._currentSectors && this._currentSectors.length){
                  let foundIndex = this._currentSectors.findIndex( (s:any)=>{
                    return s.uid == change.id;
                  });
                  if(~foundIndex){
                    this._currentSectors.splice(foundIndex,1);
                    this.currentSectors$.next( this._currentSectors );
                  }
                }
              }else{

                const newSector = new Sector(doc);
                if (this._currentSector && this._currentSector.uid == change.id) {
                                      console.log("UPDATED CURRENT SECTOR")
                  this._currentSector = newSector;
                  this.currentSector$.next(this._currentSector);
                }
                if (this._currentSectors && this._currentSectors.length) {
                  const foundIndex = this._currentSectors.findIndex((p: any) => {
                    return p.uid == change.id;
                  });
                  if (~foundIndex) {
                    console.log("UPDATED LOCAL SECTORS")
                    this._currentSectors[foundIndex] = newSector;
                    this.currentSectors$.next(this._currentSectors);
                  } else {
                    this._currentSectors.push(newSector);
                    this.currentSectors$.next(this._currentSectors);
                  }
                }



              }
          }else{
            console.warn('unknown change', change );
          }
        }
      }).on('error', (err)=> {
        console.error(err)
      });
      return api;
    })
  }

  async subscribeToSyncEvents( handler: Function ){
      try{
        await this.api.whenReady();
      }catch(E){
        this.notifier.error(E.message);
      }
      return this.api.subscribe( handler );
    }

async whenReady() {
  let resolver;
  let rejector;
  if(!this.api){
    let waiter =  new Promise( ( resolve, reject )=>{
      resolver = resolve;
      rejector = reject;
    });
    let sub = await this._apiAvailable$.subscribe( ( state )=>{
      if(state){
        this.api.whenReady().then( resolver, rejector );
        sub.unsubscribe()
      }
    })
    return waiter;

  }
    return this.api.whenReady();
  }

  async fetchFilterOptions( sectorId:string ){
    if(!this._filterOptions){
      let rows:any[] = [];
      let grouped:any = {};
      try{
        const result = await remoteDB.query('app_indexes/filter_options',{reduce: true,group: true, group_level: 2});
        rows = result.rows;
      }catch(E){
        rows = [];
      }
      rows.forEach( ( row )=>{
        const [sector,attribute] = row.key;
        const values = row.value;
        if(!grouped[sector]){
          grouped[sector]={};
        }
        grouped[sector][attribute] = values;
      })
      console.log('settings filter options', grouped);
      this._filterOptions = grouped;
    }
    console.log(this._filterOptions,sectorId)
    return this._filterOptions[sectorId];
    // let docs = rows.map( (row:any)=>{
    //   return row.doc;
    // })

    // this._conflicts = docs;
    // this.conflicts$.next( this._conflicts );

  }

  async fetchSectors() {
    const result = await this.api.getAllSectors();
    const sortedByName = result.sort((a: any, b: any) => {
      a = a.name;
      b = b.name;
      return a > b ? 1 : b > a ? -1 : 0;
    });
    this._currentSectors = sortedByName;
    this.currentSectors$.next(this._currentSectors);
    return sortedByName;
  }

  async fetchConflicts() {

    let rows:any[] = [];
    let sectors:any = {};
    try{
      const result = await remoteDB.query('app_indexes/conflicted',{conflicts:true,include_docs:true});
      rows = result.rows;
    }catch(E){
      rows = [];
    }
    try{
      const result = await remoteDB.query('app_indexes/sector_index');
      result.rows.forEach( ( row )=>{
        sectors[row.key]=row.value;
      })

    }catch(E){
      console.log(E);
      sectors = {};
    }
    let docs = rows.map( (row:any)=>{
      let doc = row.doc;
      if(!doc.meta){
        doc.meta = {};
      }
      doc.meta.sectorName = sectors[doc.sector];
      return doc;

    })

    this._conflicts = docs;
    this.conflicts$.next( this._conflicts );
    return docs;

  }
  async expandConflict(docid:string){
    let master = await remoteDB.get(docid, { conflicts: true});
    let copies = [];
    for(let rev of master._conflicts){
      let copy = await remoteDB.get(docid, { rev });
      copies.push(copy);
    }

    return {...master,...{_revisions:copies}};
  }
  async repairConflict(docid:string,updateData:any,staleRevs:string[]){
    let current = await remoteDB.get(docid);
    let updated = Object.assign( current, updateData );
    for(let rev of staleRevs.slice(1)){
      try{
      await remoteDB.remove( docid, rev );
      }catch(E){
        console.log('could not dlete ',docid, rev)
      }
    }
          try{
            let update = await remoteDB.put( updated );
          }catch(E){
            console.log('update failed',E)
            }

            this.fetchConflicts();
    // console.log({repairConflict:{docid,updateData, staleRevs, current, update }});
  }

  async getSectorAttachments(suid: string) {
    const result = await this.api.getSectorAttachments(suid);
    return result;
  }
  async deletePile(puid: string) {
    const result = await this.api.deletePile(puid);
    if (this._currentPile && this._currentPile.uid == puid) {
      this._currentPile = undefined;
      this.currentPile$.next(this._currentPile);
    }
    if (this._currentSectorPiles && this._currentSectorPiles.length) {
      const foundIndex = this._currentSectorPiles.findIndex((p: any) => {
        return p.uid == puid;
      });
      if (~foundIndex) {
        this._currentSectorPiles.splice(foundIndex, 1);
        this.currentSectorPiles$.next(this._currentSectorPiles);
      }
    }
    return result;
  }

  async renamePile(data: any) {
    const oldPile = await this.api.getPile(data.uid);
    const newPile = oldPile.toJSON();
    newPile.id = data.newNumber;
    newPile._id = data.newUID;
    newPile.uid = data.newUID;
    ['created', 'modified', 'transported'].forEach((timeprop: string) => {
      if (newPile.hasOwnProperty(timeprop)) {
        newPile[timeprop] = newPile[timeprop] ? new Date(newPile[timeprop]) : newPile[timeprop];
      }
    })
    const created = await this.api.createPile(newPile.sector, data.newNumber, newPile);
    if (created) {
      await this.deletePile(data.uid);
    }
    if (this._currentPile && this._currentPile.uid == data.uid) {
      this._currentPile = created;
      this.currentPile$.next(this._currentPile);
    }
    if (this._currentSectorPiles && this._currentSectorPiles.length) {
      const foundIndex = this._currentSectorPiles.findIndex((p: any) => {
        return p.uid == data.uid;
      });
      if (~foundIndex) {
        this._currentSectorPiles.splice(foundIndex, 1, created);
        this.currentSectorPiles$.next(this._currentSectorPiles);
      }
    }
    return true;
  }
  async updateSector(mods: any) {
    let { original, data } = mods;
    original = { ...original };
    data = { ...data };
    if (!original.roadInfo) {
      original.roadInfo = {};
    }
    Object.assign(original.roadInfo, data.roadInfo);
    if (data.name) {
      original.name = data.name.toUpperCase();
    }
    if (data.status) {
      original.status = data.status;
    }
    if (data.created) {
      original.created = data.created;
    }
    original.teams = data.teams;
    original.roads = data.roads;
    const updated = await this.api.updateSector(original);
    if (this._currentSector && this._currentSector.uid == original.uid) {
      this._currentSector = updated;
      this.currentSectors$.next(this._currentSector);
    }
    if (this._currentSectors && this._currentSectors.length) {
      const foundIndex = this._currentSectors.findIndex((p: any) => {
        return p.uid == original.uid;
      });
      if (~foundIndex) {
        this._currentSectors.splice(foundIndex, 1, updated);
        this.currentSectors$.next(this._currentSectors);
      }
    }

    return updated;
  }
  async updatePile(mods: any) {
    let { original, data } = mods;
    original = { ...original };
    data = { ...data }
    const flats = ["road", "team", "operation", "status", "created", "modified", "transported"];
    flats.forEach((flat: string) => {
      if (data[flat] != original[flat]) {
        original[flat] = data[flat];
      };
    });
    if (data.logLength) {
      original.measures.logLength = data.logLength;
    }
    if (data.length) {
      original.measures.length = data.length;
    }
    if (data.height) {
      original.measures.heights = [data.height];
    }
    const updated = await this.api.updatePile(original);
    if (this._currentPile && this._currentPile.uid == original.uid) {
      this._currentPile = updated;
      this.currentPile$.next(this._currentPile);
    }
    if (this._currentSectorPiles && this._currentSectorPiles.length) {
      const foundIndex = this._currentSectorPiles.findIndex((p: any) => {
        return p.uid == original.uid;
      });
      if (~foundIndex) {
        this._currentSectorPiles.splice(foundIndex, 1, updated);
        this.currentSectorPiles$.next(this._currentSectorPiles);
      }
    }
    return updated;

  }
  async getSector(sid: string) {
    await this.whenReady();
    const result = await this.api.getSector(sid);
    this._currentSector = result;
    this.currentSector$.next(this._currentSector);
    return result;
  }

  async createSector(name: string) {
    const result = await this.api.createSector({ "name": name, "status": "closed" });
    this._currentSector = result;
    this.currentSector$.next(this._currentSector);
    return result;
  }
  async createPile(sid: string, no: string) {
    const result = await this.api.createPile(sid, no);
    this._currentPile = result;
    this.currentPile$.next(this._currentPile);
    return result;
  }

  async getSectorPiles(sid: string) {
    const result = await this.api.getPilesForSector(sid);
    const mapped = result.map((p) => {
      if (!p.roadInfo && p.roadTypes) {
        p.roadInfo = Object.keys(p.roadTypes).reduce((info: any, name: string) => {
          let type = p.roadTypes[name];
          if (type == 'HIVER') {
            type = 'H';
          } else {
            type = 'G';
          }
          info[name] = { number: name, season: type, year: null };
          return info;
        }, {});
      }
      return p;
    });
    this._currentSectorPiles = mapped;
    this.currentSectorPiles$.next(mapped);


    return mapped;
  }

  async getReportPiles(){
    await this.whenReady();
        let rows:any[] = [];
        let sectorNames:any = await this.getSectorNames();
        try{
          const result = await remoteDB.query('app_indexes/report_piles',{include_docs:true});
          rows = result.rows;
        }catch(E){
          rows = [];
        }
        let docs = [];
        for(const row of rows){
          const doc = row.doc;
          if(!doc.meta){
            doc.meta = {};
          }
          if(!doc.meta.sectorName){
            doc.meta.sectorName = sectorNames[doc.sector];
          }
          docs.push(doc)
        }
        return docs.map( d=> new Pile(d));
  }
  async getSectorNames(){
    await this.whenReady();
    let rows:any[]=[];
    let nameMap:{[x:string]:string} = {};
    try{
      const result = await remoteDB.query('app_indexes/sector_index');
      rows = result.rows;
    }catch(E){
      rows = [];
    }
    rows.forEach( ( r)=>{
      nameMap[r.key]=r.value;
    })
    return nameMap;
  }
  async getSectorName(sid:string){
    await this.whenReady();
    let sector = await remoteDB.get(sid);
    return sector.name;
  }
}
